import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsNavigationComponent } from './transport-interventions-navigation.component';
import {DxDropDownButtonModule} from 'devextreme-angular';



@NgModule({
  declarations: [TransportInterventionsNavigationComponent],
  imports: [
    CommonModule,
    DxDropDownButtonModule
  ],
  exports: [TransportInterventionsNavigationComponent]
})
export class TransportInterventionsNavigationModule { }
